import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { SetupExcpParam, ItemList, resBoxProc, BoxAprvReq } from 'models/setup/excp/excp';
import { callApi } from 'utils/ApiUtil';

export const getSetupBoxList = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/boxList`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<ItemList[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as ItemList[];
};

export const getProjectBoxCnt = async (condition: SetupExcpParam) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/boxListCnt`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<SetupExcpParam> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupExcpParam;
};

export const saveBoxList = async (condition: ItemList) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/saveSetupBox`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const updateBoxProcedure = async (condition: ItemList) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/updateBoxProcedure`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };
  const response: CommonResponse<resBoxProc> = await callApi(request);
  return response;
};

export const saveBoxApproveRequest = async (data: BoxAprvReq[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/box/approve-request`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: data,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

export const findBoxApproveRequestHistory = async (condition: BoxAprvReq) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/box/approve-request/history`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({
      ...condition,
    }),
  };
  const response: CommonResponse<BoxAprvReq[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as BoxAprvReq[];
};

export const BoxApproveRequestApprove = async (data: ItemList[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/box/approve-request/approve`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: data,
  };
  const response: CommonResponse<any> = await callApi(request);
  return response;
};

export const BoxApproveRequestReject = async (data: ItemList[]) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/box/approve-request/reject`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: data,
  };
  const response: CommonResponse<any> = await callApi(request);
  return response;
};
